/* eslint-disable max-lines */
import {
    ListAllAfterSaleQuestionUsingGetParams,
    ListAllAfterSaleQuestionResult,
    SaveAfterSaleQuestionParam,
    FindInterceptSettingUsingGetParams,
    FindInterceptSettingResult,
    ModifyInterceptSettingParam,
    QueryOrderStatusUsingGetParams,
    QueryOrderStatusResult,
    AlreadyInterceptionOrderQueryParam,
    WaitInterceptionOrderQueryParam1,
    ResultUsingGetParams,
    GetProcessResultUsingGetParams,
    UpdateProcessResultResp,
    QueryAfterSalesOrderPrintSettingUsingGetParams,
    AfterSaleSyncReturnAddressParam,
    QuerySupplierAllowReturnAddressUsingGetParams,
    LoadReturnAddressResult,
    GetSupplierAssociatedRuleStatusUsingGetParams,
    GetLevelSupplierReturnAddressUsingGetParams,
    AfterSaleReturnAddressResult,
    SupplierReturnAddressResult,
    AfterSaleMiddlemanAddressParam,
    QueryAddressBySupplierCoIdUsingGetParams,
    AfterSaleMiddlemanAddressResult,
    QueryPhoneUsingGetParams,
    DeleteAddressUsingGetParams,
    ListOperationLogUsingGetParams,
    AfterSaleOperationLogResult,
    RecommendReturnAddressResult,
    QuerySupplierAddressRuleStatusResult,
    PageSupplierReturnAddressUsingGetParams,
    ReturnAddressVo,
    MultiDisShareInfoConfigParam,
    GetMultiDisShareInfoConfigUsingGetParams,
    ListSwitchUsingGetParams,
    UConfigSwitchResult,
    GetOwnDistRefundOnlyCertRequiredUsingGetParams,
    EditDistributorReissueVoucherSwitchParam,
    UConfigSwitchParam,
    GetDrpCoIdToSwitchUsingGet1Params,
    GetSupDistRefundOnlyCertRequiredUsingGetParams,
    QueryRuleShopListUsingGetParams,
    QueryAddressRuleShopResult,
    MatchRuleShopUsingGetParams,
    DeletedAddressRuleParam,
    CreateAddressRuleParam,
    UpdateApplyShopParam,
    ListUsingGetParams,
    PageAutoRuleResult,
    CreateAfterSaleAutoRuleParam,
    AutoRuleSaveResult,
    UpdateAfterSaleAutoRuleParam,
    CheckAgSettingConsistentUsingGetParams,
    AgSettingResult,
    GetShopLocationRuleUsingGetParams,
    AgRuleResult,
    ListUsingGet1Params,
    ListRuleLogResult,
    LoadUsingGetParams,
    LoadAfterSaleAutoRuleResult,
    GetDefaultRuleConfigurationUsingGetParams,
    HasAllPushToSupplierRuleUsingGetParams,
    ChangeEnableParam,
    VerificationRuleParam,
    SuccessFailResult,
    DeleteAfterSaleAutoRuleParam,
    DrpRefundAmountResult,
    ShareInfoResult,
    QueryAfterSalesOrderProgressDetailUsingGetParams,
    QuerySupplierLogisticsTrackInfoUsingGetParams,
    SupplierLogisticsTrackInfoVo,
    OperationLogResult,
    QueryOwnRefundRuleUsingGetParams,
    AfterSaleRefundRuleVo,
    SaveRefundRuleParam,
    QuerySupplierRefundRuleUsingGetParams,
    QueryPreSuppliersWithRefundRulesParam,
    QueryPreSuppliersWithRefundRulesVo,
    CheckIfSupplierHasSetRefundRuleUsingGetParams,
    QuerySuppliersWithRefundRuleParam,
    HasRefundRuleByOrderIdParam,
    HasRefundRuleByOrderIdVo,
    CheckIfUserHasSetRefundRuleUsingGetParams,
    QueryRuleLogParam,
    AfterSaleRuleLogVoObject,
    BatchUpdateRefundAmountVo,
    BatchUpsertShareParam,
    CountUsingGetParams,
    GetNoteTemplateUsingGetParams,
    AfterSaleNoteTemplateResult,
    NoteTemplateLogResult,
    QuerySelectedThirdPartyWarehousesUsingGetParams,
    QueryThirdWarehouseListUsingGetParams,
    QueryThirdWarehouseByAutoRuleIdUsingGetParams,
    AfterSaleReturnAddressParam,
    EnableRuleProcessUsingGetParams,
    EnableRuleProcessResult,
    AfterSaleOrderStatisticsBySoIdResult,
    GetIgnoreSmsCodeUsingGetParams,
    LoadReturnAddressUsingGetParams,
    MultilevelShopAddressMatchParam,
    MultilevelShopAddressMatchVo,
    MultilevelShopAddressParam,
    MultilevelShopAddressVo,
    QueryShopAddressListParam,
    QueryShopAddressListVO,
    CreateShopAddressParam,
    UpdateShopAddressVO,
    BatchUpdateShopAddressParam,
    DeleteBaseAddressParam,
    BatchRemoveShopAddressParam,
    RemoveShopAddressParam,
    UpdateShopAddressParam,
    GetTaskProgressUsingGetParams,
    AsyncProcessingResultVoObject,
    DecryptAddressUsingGetParams,
    EqualsAddressParam,
    EqualsAddressVO,
    LogisticsAfterSaleStatResultVo,
    QueryShopAddressNumByIdsParam,
    QueryShopAddressNumByIdsVO,
    QueryReturnAddressLogsUsingGetParams,
    ReturnAddressChangeLogVo,
    GetRefundToDistributorCanAllDrpUsingGetParams,
    DrpNamesUsingGetParams,
    CoIdNameResult,
    GetValidRefundToDistributorRuleListUsingGetParams,
    AfterSaleAutoRuleCollectSimpleVO,
    GetRefundToDistributorOtherRuleVO,
    GetRefundToDistributorOtherRuleParam,
    BaseAddressShopUsingGetParams,
    BaseAddressShopVO,
    BaseAddressShopCheckUsingGetParams,
    CountPendingSupplierSubmissionsVO,
    QueryTargetProvinceAndCityUsingGetParams,
    TargetProvinceAndCityVo,
    LevelSupplierReturnAddressV2UsingGetParams,
    GetShopDropShippingProductCountParam,
    ShopDropShippingProductCountVo,
    GetShopDropShippingProductUsingGetParams,
    ShopDropShippingProductVo,
    GenerateMultiReturnPoliciesForDropShippingVo,
    LevelSupplierReturnAddressVo,
    ReturnAddressSyncUploadRecordVo,
    QueryReturnAddressSyncUploadRecordDetailsUsingGetParams,
    ReturnAddressSyncUploadRecordDetailVo,
    QueryChangedSupplierReturnAddressByRecordIdUsingGetParams,
    ChangedSupplierReturnAddressVo,
    QueryReturnAddressSyncUploadRecordItemDetailsUsingGetParams,
    ReturnAddressSyncUploadRecordItemDetailVo,
    QueryReturnAddressSyncUploadRecordByIdUsingGetParams,
    ReloadReturnAddressStrategyParam,
    PreVerifySpeedRefundEligibilityVo,
    CountUploadReturnAddressStrategyRecordItemCountVo
} from '@servicesTypings/towerAftersaleRequest'
import {
    SimplePartnerParam,
    SimplePartnerVo,
    GetDisclaimerUsingGetParams,
    DisclaimerVo,
    MySupplierCountUsingGet1Params,
    MyChannelCountUsingGet1Params,
    MySupplierSimpleParam,
    AfterSaleAddressSyncSwitchResult,
    ListSupplierNameAfterSaleAutoUsingGetParams,
    SupplierNameValueVo,
    WaitAuthChannelVo,
    ListSuppliersAfterSaleAutoUsingGetParams,
    SupplierAfterSaleAutoVo,
    WaitAuthSupplierVo,
    BatchRevokeApplyParam,
    QueryOptionsUsingGetParams,
    MyChannelSimpleResult
} from '@servicesTypings/drpRequest'
import {
    ListAfterSaleGoodsDetailUsingGetParams,
    AfterSaleItemInfoVO,
    AfterSaleGoodsUpdateDTO,
    GetVideoMonitorInfoByAsIdUsingGetParams,
    VideoMonitorInfoVo,
    VideoDataInfoDTO,
    AfterSaleGoodsDelDTO,
    AfterSaleItemInfoVO1,
    AftersaleGetReturnPhoneUsingGetParams,
    AftersaleGetSupplierReturnPhoneUsingGet1Params,
    AfterSaleFeedbackDTO,
    SelectItem,
    ModifyReceivingWarehouseParam,
    UpdateWmsCoIdDTO,
    AfterSaleSyncOwnerDTO,
    ErpAfterSaleActionResultVO,
    OwnerListVo,
    GetWeChatSubscriptionQrCodeUsingGetParams,
    SelectItemUsingGetParams,
    ErpAfterSaleSelectItemVO,
    GetExportResultUsingGetParams,
    ExportResultVo,
    ListExportLogUsingGetParams,
    ExportLogVo,
    ReturnGoodsRefundDTO,
    ErpAfterSaleReturnRefundResultVo,
    QuerySaleReturnGoodsAddressDTO,
    ErpAfterSaleReturnGoodsAddressVo,
    QueryRefuseReasonUsingGetParams,
    ErpAfterSaleRefuseReasonVO,
    QueryRejectReasonDTO,
    ErpAfterSaleRejectVO,
    RefuseDTO,
    ShopAccountDTO,
    IsLogisticsInterceptionAuthUsingGetParams,
    GetLogisticsInterceptionSensitiveConfigUsingGetParams,
    LogisticsInterceptionAuthConfigVO,
    LogisticsInterceptionAuthConfigDTO,
    GetLogisticsInterceptionConfigUsingGetParams,
    LogisticsInterceptionInitiateDTO,
    LogisticsInterceptionVO,
    LogisticsInterceptionCommonDTO,
    AbstractLogisticsInterceptionVO,
    ConfirmReceiptGoodsDTO,
    UnConfirmGoodsDTO,
    CancelSupplierDTO,
    ReturnGoodsFirstAuditAgreeV2DTO,
    CheckShopSubAccountUsingGetParams,
    DownloadAfterSaleOrderDTO,
    AfterSaleSyncReps,
    CreateAsyncTaskResult,
    QueryAfterSaleOrderShopDTO,
    GylErpShopInfo8,
    AfterSaleStatisticsActionUsingGet1Params,
    ErpAfterSaleCountVO,
    AfterSaleDataStatisticsAutoVO,
    ListShopAfterSaleAutoUsingGetParams,
    ShopAfterSaleAutoVo,
    ShopVo,
    ListShopNameAfterSaleAutoUsingGetParams,
    AfterSaleConfirmDTO,
    ErpAfterSaleConfirmVO,
    UnCancelDTO,
    ListAfterSaleByOrderNoGoodsUsingGetParams,
    ErpAfterSaleGoodsVo,
    AfterSaleDTO,
    SelfCreateNoInformationAfterSaleDTO,
    AfterSaleSelfCreateVo,
    AfterSaleRefundGoodsCodeDTO,
    FastRefundDTO,
    CheckSupplierRefundFinishVo,
    AfterSaleNoInformationGoodsDTO,
    ListAfterSaleByIdsGoodsUsingGetParams,
    GetAutoRuleLogUsingGetParams,
    AfterSaleAutoRuleLogVo,
    QueryAfterSaleNoInformationGoodsDetailDTO,
    NoInformationBindOrderSkuVo,
    NoInformationBindOrderDTO,
    AfterSaleNoInformationBindOrderVo,
    LogisticsTrailVo,
    UnConfirmDTO,
    ImageUpdateDTO,
    AfterSaleImage,
    CancelExceptionDTO,
    ShareInfoDTO,
    HasShareInfoUsingGetParams,
    HasShareInfoVO,
    ConfigOfflineNoteDTO,
    BindOfflineNoteDTO,
    AfterSaleBindOfflineNoteVo,
    AfterSaleNoteTemplateDTO,
    OrderToAfterSaleAmountVo,
    AfterSalesExceptionVo,
    QueryAfterSalesLabelListVo,
    SaveAfterSalesLabelDTO,
    SaveAfterSalesLabelVo,
    SetLabelToAfterSalesOrderDTO,
    SetLabelToAfterSalesOrderVo,
    LogisticsStatusVo,
    SubmitSupplierDTO,
    SelfCreateAfterSaleDTO,
    LiteOrderArchiveInfoVO,
    DisAfterSaleStatisticsActionUsingGetParams,
    AfterSaleIssueTreeNodeVo
} from '@servicesTypings/companyRequest'
import {
    AfterSaleQueryDTO,
    SaleOrderVO,
    AfterSaleOrderExportDTO,
    AfterSaleExportVo,
    DisAfterSaleOrderExportDTO,
    DisAfterSaleQueryDTO,
    DisSaleOrderVo,
    InnerOrderListParam,
    SimpleOrderListView,
    OrderAfterSaleDTO,
    OrderDisSendVo,
    QueryOrderSoIdParam,
    OrderBriefInfoVo,
    CurrentUser
} from '@servicesTypings/towerRequest'

import { ReturnQuantityType } from '@/modules/afterSale/components/PrintDpAndSkuAction/typing'
import {
    companyRequest,
    towerRequest,
    securityRequest,
    towerAftersaleRequest,
    drpRequest,
    payRequest
} from '@/utils/request'

/**
 * 下面是新售后管理相关接口
 */
// 查询售后退货地址手机号
export function queryArchive() {
    return companyRequest.get('/afterSale/queryArchive')
}
// 查询售后退货地址手机号
/**
 * 查询售后退货地址手机号
 */
export function getReturnPhone(params: AftersaleGetReturnPhoneUsingGetParams): API.Res<string> {
    return companyRequest.get('/phoneQuery/aftersale/getReturnPhone', { params })
}

// 查询供应商对应的退货地址手机号
/**
 * 查询供应商对应的退货地址手机号
 */
export function getReturnPhoneSupplier(params: AftersaleGetSupplierReturnPhoneUsingGet1Params): API.Res<string> {
    return companyRequest.get('/phoneQuery/aftersale/supplier/getReturnPhone', { params })
}

// 查询供应商退货地址
/**
 * 查询供应商退货地址
 */
export function querySupplierReturnAddress(
    params: QuerySupplierAllowReturnAddressUsingGetParams
): API.Res<LoadReturnAddressResult> {
    return towerAftersaleRequest.get('/addresses/querySupplierReturnAddress', { params })
}

/** 查询供应商所在规则的状态 */
/**
 * 查询供应商所在规则的状态 (转换包含中文无法完全转换)
 */
export function getSupplierAssociatedRuleStatusApi(
    params: GetSupplierAssociatedRuleStatusUsingGetParams
): API.Res<any> {
    return towerAftersaleRequest.get('/automation/getSupplierAssociatedRuleStatus', { params })
}

// 售后极速版返回旧版增加反馈建议通道
/**
 * 售后反馈
 */
export function afterSaleFeedback(data: AfterSaleFeedbackDTO): API.Res<null> {
    return companyRequest.post('/afterSale/feedback', { data })
}

// 询多级供应商退货地址
/**
 * 查询多级供应商退货地址
 */
export function levelSupplierReturnAddress(
    params: GetLevelSupplierReturnAddressUsingGetParams
): API.Res<AfterSaleReturnAddressResult> {
    return towerAftersaleRequest.get('/addresses/levelSupplierReturnAddress', { params })
}

/**
 * 查询多级供应商退货地址V2
 */
export function levelSupplierReturnAddressV2UsingGET(
    params: LevelSupplierReturnAddressV2UsingGetParams
): API.Res<AfterSaleReturnAddressResult> {
    return towerAftersaleRequest.get('/addresses/levelSupplierReturnAddressV2', { params })
}

// 获取免责申明
/**
 * 获取免责申明
 */
export function getDisclaimer(params: GetDisclaimerUsingGetParams): API.Res<DisclaimerVo> {
    return drpRequest.get('/company/getDisclaimer', { params })
}

// 查询分仓
/**
 * 查询分仓
 */
export function findReceivingWarehouseApi(): API.Res<SelectItem[]> {
    return companyRequest.get('/afterSale/warehouses/findReceivingWarehouse')
}

// 查询分仓带权限
/**
 * 查询分仓根据权限
 */
export function findReceivingWarehouseByAuthApi(): API.Res<SelectItem[]> {
    return companyRequest.get('/afterSale/warehouses/findReceivingWarehouseByAuth')
}

// 售后单修改收货仓
/**
 * 售后单修改收货仓
 */
export function modifyReceivingWarehouseApi(data: ModifyReceivingWarehouseParam): API.Res<UpdateWmsCoIdDTO> {
    return companyRequest.post('/afterSale/warehouses/modifyReceivingWarehouse', { data })
}

// 售后单修改收货仓
/**
 * 同步三方仓
 */
export function afterSaleOwnerSyncOwner(data: AfterSaleSyncOwnerDTO): API.Res<ErpAfterSaleActionResultVO> {
    return companyRequest.post('/after-sale/owner/syncOwner', { data })
}

// 三方仓列表查询
/**
 * 查询三方仓列表
 */
export function wmsOwnerList(): API.Res<OwnerListVo[]> {
    return companyRequest.get('/wms/owner/list')
}

// 查询是否包含跨境业务
/**
 * 判断是否包含跨境
 */
export function hasCrossBorderApi(): API.Res<boolean> {
    return companyRequest.get('/afterSale/crossBorder/hasCrossBorder')
}

/**
 *
 * 售后微信公众号订阅二维码
 */
/**
 * 微信公众号订阅二维码(临时二维码)
 */
export function getWeChatSubscriptionQRCodeApi(params: GetWeChatSubscriptionQrCodeUsingGetParams): API.Res<string> {
    return companyRequest.get('/wechat/officialAccount/getWeChatSubscriptionQRCode', { params })
}

// 查询供应商退货地址列表
/**
 * 查询供应商退货地址列表
 */
export function listSupplierReturnAddress(data: integer[]): API.Res<SupplierReturnAddressResult[]> {
    return towerAftersaleRequest.post('/addresses/listSupplierReturnAddress', { data })
}

/**
 * 保存地址
 */
/**
 * 保存地址
 */
export function middlemanSaveApi(data: AfterSaleMiddlemanAddressParam): API.Res<null> {
    return towerAftersaleRequest.post('/middleman/addresses/save', { data })
}

/**
 * 修改地址
 */
/**
 * 修改地址
 */
export function middlemanUpdateApi(data: AfterSaleMiddlemanAddressParam): API.Res<null> {
    return towerAftersaleRequest.post('/middleman/addresses/update', { data })
}

/**
 * 查询地址
 */
/**
 * 根据id查询中间商手动维护地址
 */
export function middlemanQueryAddressBySupplierCoIdApi(
    params: QueryAddressBySupplierCoIdUsingGetParams
): API.Res<AfterSaleMiddlemanAddressResult> {
    return towerAftersaleRequest.get('/middleman/addresses/queryAddressBySupplierCoId', { params })
}

/**
 * 查询中间商手动维护地址手机号
 */
/**
 * 查询中间商手动维护地址手机号
 */
export function middlemanQueryPhoneApi(params: QueryPhoneUsingGetParams): API.Res<string> {
    return towerAftersaleRequest.get('/middleman/addresses/queryPhone', { params })
}

/**
 * 删除中间商地址信息
 */
/**
 * 删除中间商地址信息
 */
export function deleteAddressApi(params: DeleteAddressUsingGetParams): API.Res<null> {
    return towerAftersaleRequest.get('/middleman/addresses/deleteAddress', { params })
}

// 售后管理 搜索区下拉字典
/**
 * 售后管理-下拉菜单
 */
export function getAfterSelectItem(params: SelectItemUsingGetParams): API.Res<ErpAfterSaleSelectItemVO> {
    return companyRequest.get('/afterSale/dictionaries', { params })
}

// 售后单列表接口
/**
 * 售后管理-售后订单列表
 */
export function afterSaleList(data: AfterSaleQueryDTO): API.Res<SaleOrderVO[]> {
    return towerRequest.post('/after-sale/page/list', { data })
}

// 售后管理-导出售后单
/**
 * 售后管理-导出售后单
 */
export function exportAfterSale(data: AfterSaleOrderExportDTO): API.Res<AfterSaleExportVo> {
    return towerRequest.post('/after-sale/export', { data })
}

// 分销商售后单导出接口
/**
 * 售后管理-导出分销商售后单
 */
export function exportDisAfterSale(data: DisAfterSaleOrderExportDTO): API.Res<AfterSaleExportVo> {
    return towerRequest.post('/after-sale/dis/export', { data })
}

// 售后管理-查询导出结果
/**
 * 售后管理-查询导出结果
 */
export function getExportProgress(params: GetExportResultUsingGetParams): API.Res<ExportResultVo> {
    return companyRequest.get('/afterSale/logs/export/result', { params })
}

// 售后管理-查询导出日志
/**
 * 售后管理-查询导出日志
 */
export function getAfterSaleExportLog(params: ListExportLogUsingGetParams): API.Res<ExportLogVo[]> {
    return companyRequest.get('/afterSale/logs/export/log', { params })
}

// 售后管理-同意退款
/**
 * 售后管理-同意退款
 */
export function refundsAgree(data: ReturnGoodsRefundDTO): API.Res<ErpAfterSaleReturnRefundResultVo> {
    return companyRequest.post('/after/refunds/agree', { data })
}

// 售后管理-获取退货收货地址集合
/**
 * 获取退货收货地址集合
 */
export function getReturngoodsAddress(
    data: QuerySaleReturnGoodsAddressDTO[]
): API.Res<ErpAfterSaleReturnGoodsAddressVo[]> {
    return companyRequest.post('/afterSale/addresses/returnGoods', { data })
}

// 售后管理-列表-查看拒绝理由
/**
 * 售后管理-【查看拒绝理由】
 */
export function getItemRefuseReason(params: QueryRefuseReasonUsingGetParams): API.Res<ErpAfterSaleRefuseReasonVO> {
    return companyRequest.get('/after/refuse/reason', { params })
}

// 售后管理-获取拒绝理由
/**
 * 售后管理-获取拒绝理由
 */
export function getRejectReasonList(data: QueryRejectReasonDTO): API.Res<ErpAfterSaleRejectVO[]> {
    return companyRequest.post('/after/reject/reason/list', { data })
}

// 售后管理-【拒绝退款】
/**
 * 售后管理-【拒绝退款】
 */
export function afterRefundApi(data: RefuseDTO): API.Res<ErpAfterSaleActionResultVO> {
    return companyRequest.post('/after/refuse/refund', { data })
}

// 售后管理-【一审拒绝退货】
/**
 * 售后管理-【一审拒绝退货】
 */
export function afterReturnGoodsFirstApi(data: RefuseDTO): API.Res<ErpAfterSaleActionResultVO> {
    return companyRequest.post('/after/refuse/returnGoodsFirst', { data })
}

// 售后管理-【二审拒绝退货】
/**
 * 售后管理-【二审拒绝退货】
 */
export function afterReturnGoodsSecondApi(data: RefuseDTO): API.Res<ErpAfterSaleActionResultVO> {
    return companyRequest.post('/after/refuse/returnGoodsSecond', { data })
}

interface AfterAccountsListChildUserListType {
    userId: string
    userName: string
}

export interface AfterAccountsListChildType {
    accountName: string
    accountCode: string
    authorized: boolean
    disable: boolean
    expired: boolean
    status: number
    // refundAuthority 优先级最高
    refundAuthority: boolean | null | undefined
    default: boolean
    userList: AfterAccountsListChildUserListType[]
}

export interface AfterAccountsListItem {
    children: AfterAccountsListChildType[]
    shopSite: string
    shopName: string
    shopId: string
    authUrl: string
    noRefundAuth: boolean
}

type AfterAccountsList = AfterAccountsListItem[]

interface AfterAccountParams {
    shopIds?: any
}

/** 售后管理-获取子账号信息 */
export function accounts(params: AfterAccountParams): Promise<API.RootObject<AfterAccountsList>> {
    return companyRequest.get('/afterSale/accounts/page', {
        params
    })
}

// 售后管理-设置默认子账号
/**
 * 售后管理-设置默认子账号
 */
export function accountsSetting(data: ShopAccountDTO): API.Res<object> {
    return companyRequest.post('/afterSale/accounts/setting', { data })
}

// 查询物流拦截是否授权
/**
 * 查询物流拦截是否授权
 */
export function logisticsInterceptionAuthApi(params: IsLogisticsInterceptionAuthUsingGetParams): API.Res<boolean> {
    return companyRequest.get('/afterSale/logisticsInterceptionAuth/isAuth', { params })
}

// 查询物流拦截授权敏感信息
/**
 * 查询物流拦截授权敏感信息
 */
export function logisticsInterceptionAuthSensitive(
    params: GetLogisticsInterceptionSensitiveConfigUsingGetParams
): API.Res<LogisticsInterceptionAuthConfigVO> {
    return companyRequest.get('/afterSale/logisticsInterceptionAuth/sensitive', { params })
}

// 保存物流拦截授权信息
/**
 * 保存物流拦截授权信息
 */
export function logisticsInterceptionAuthSaveApi(data: LogisticsInterceptionAuthConfigDTO): API.Res<boolean> {
    return companyRequest.post('/afterSale/logisticsInterceptionAuth/save', { data })
}

// 查询物流拦截授权明文信息
/**
 * 查询物流拦截授权明文信息
 */
export function logisticsInterceptionAuthPlaintext(
    params: GetLogisticsInterceptionConfigUsingGetParams
): API.Res<LogisticsInterceptionAuthConfigVO> {
    return companyRequest.get('/afterSale/logisticsInterceptionAuth/plaintext', { params })
}

// 售后管理发起物流拦截授
/**
 * 售后管理发起物流拦截授
 */
export function logisticsInterceptionInitiate(
    data: LogisticsInterceptionInitiateDTO
): API.Res<LogisticsInterceptionVO> {
    return companyRequest.post('/afterSale/logisticsInterception/initiate', { data })
}

// 分销商的售后单发起物流拦截
/**
 * 分销商的售后单发起物流拦截
 */
export function logisticsInterceptionDisInitiate(
    data: LogisticsInterceptionInitiateDTO
): API.Res<LogisticsInterceptionVO> {
    return companyRequest.post('/afterSale/logisticsInterception/disInitiate', { data })
}

// 售后管理更新物流拦截状态
/**
 * 更新物流拦截状态
 */
export function logisticsInterceptionUpdate(
    data: LogisticsInterceptionCommonDTO
): API.Res<AbstractLogisticsInterceptionVO> {
    return companyRequest.post('/afterSale/logisticsInterception/update', { data })
}

// 售后管理取消物流拦截
/**
 * 取消物流拦截
 */
export function logisticsInterceptionCancel(
    data: LogisticsInterceptionCommonDTO
): API.Res<AbstractLogisticsInterceptionVO> {
    return companyRequest.post('/afterSale/logisticsInterception/cancel', { data })
}

// 售后管理-确认收货
/**
 * 售后管理-确认收货
 */
export function confirmReceiptGoods(data: ConfirmReceiptGoodsDTO[]): API.Res<ErpAfterSaleActionResultVO> {
    return companyRequest.post('/after/confirmReceiptGoods', { data })
}

// 售后管理-取消收货
/**
 * 取消收到货物
 */
export function cancelReceiptGoods(data: UnConfirmGoodsDTO): API.Res<ErpAfterSaleActionResultVO> {
    return companyRequest.post('/after-sale/supplier/unConfirmGoods', { data })
}

// 售后管理-供销拦截
/**
 * 供销拦截
 */
export function cancelSupplier(data: CancelSupplierDTO): API.Res<ErpAfterSaleActionResultVO> {
    return companyRequest.post('/after-sale/supplier/cancelSupplier', { data })
}

// 售后管理-代发售后【提交给分销商】
interface SubmitDisDataType {
    asIds: string[]
}
export function submitDis(data: SubmitDisDataType) {
    return companyRequest.post('//after-sale/issuing/submit-dis', {
        data
    })
}

// 售后管理-【一审同意退货】
/**
 * 售后管理-【一审同意退货V2】
 */
export function firstAuditAgree(data: ReturnGoodsFirstAuditAgreeV2DTO[]): API.Res<ErpAfterSaleActionResultVO> {
    return companyRequest.post('/after/returnGoods/firstAuditAgreeV2', { data })
}

// 售后管理-【二审同意退货】
/**
 * 售后管理-【二审同意退货】
 */
export function secondAuditAgree(data: ReturnGoodsRefundDTO): API.Res<ErpAfterSaleReturnRefundResultVo> {
    return companyRequest.post('/after/returnGoods/secondAuditAgree', { data })
}

// 商家店铺信息-检测是否存在某平台授权并启用的店铺
/**
 * 商家店铺信息-检测是否存在某平台授权并启用的店铺
 */
export function shopExist(params: CheckShopSubAccountUsingGetParams): API.Res<boolean> {
    return companyRequest.get('/erpShopInfo/shop/authorization/exist', { params })
}

// 售后管理-下载售后单
/**
 * 售后管理-下载售后单
 */
export function downloadAfterSaleOrder(data: DownloadAfterSaleOrderDTO): API.Res<AfterSaleSyncReps> {
    return companyRequest.post('/after/downloadAfterSaleOrderNew', { data })
}

// 售后管理-下载售后单
/**
 * 售后管理-按时间下载售后单(异步)
 */
export function asyncDownloadAfterSaleOrdersByTimeRange(
    data: DownloadAfterSaleOrderDTO
): API.Res<CreateAsyncTaskResult> {
    return companyRequest.post('/after/asyncDownloadAfterSaleOrdersByTimeRange', { data })
}

// 售后店铺列表
/**
 * 售后店铺列表
 */
export function listAfterSaleOrderShop(data: QueryAfterSaleOrderShopDTO): API.Res<GylErpShopInfo8[]> {
    return companyRequest.post('/shop/listAfterSaleOrderShop', { data })
}

// 查询角标
/**
 * 售后单据action统计
 */
export function afterSaleStatisticsAction(
    params: AfterSaleStatisticsActionUsingGet1Params
): API.Res<ErpAfterSaleCountVO[]> {
    return companyRequest.get('/afterSale/statistics/afterSaleStatisticsAction', { params })
}

/**
 * 上面是新售后管理相关接口结束
 */

// 查询操作日志
/**
 * 查询操作日志
 */
export function queryOperationLog(params: ListOperationLogUsingGetParams): API.Res<AfterSaleOperationLogResult[]> {
    return towerAftersaleRequest.get('/logs/operationLog', { params })
}

// 售后自动化统计分享
/**
 * 售后自动化统计分析
 */
export function queryStatissticsAuto(): API.Res<AfterSaleDataStatisticsAutoVO> {
    return companyRequest.get('/afterSale/statistics/auto')
}

// 查询我的供应商数量
/**
 * 查询我的供应商数量
 */
export function queryMySupplierCount(params: MySupplierCountUsingGet1Params): API.Res<number> {
    return drpRequest.get('/myPartner/mySupplierCount', { params })
}

// 查询我的分销商数量
/**
 * 查询我的分销商数量
 */
export function queryMyChannelCount(params: MyChannelCountUsingGet1Params): API.Res<number> {
    return drpRequest.get('/myPartner/myChannelCount', { params })
}

/** 售后管理-代发售后【提交给供应商】接口返回的失败信息的错误码 */
export enum FailDetailCode {
    /** 需要上传供分销备注的异常 */
    NEED_REMARK = 100,

    /** 供应商驳回的异常 */
    SUPPLIER_REJECTED = 120,

    /** 建议修改售后类型为仅退款异常 */
    REFUND_ONLY_RECOMMENDED = 101
}

/** 售后管理-代发售后【提交给供应商】 */
export function submitToSupplier(data: SubmitSupplierDTO): API.Res<ErpAfterSaleActionResultVO> {
    return companyRequest.post('/after-sale/issuing/submit-supplier', { data })
}

// 计算推荐退货地址
/**
 * 计算推荐退货地址
 */
export function recommendReturnAddressApi(data: integer[]): API.Res<RecommendReturnAddressResult[]> {
    return towerAftersaleRequest.post('/addresses/calcRecommendReturnAddress', { data })
}

// 查询供应商推送地址策略启用状态
/**
 * 查询供应商推送地址策略启用状态
 */
export function querySupplierPushAddressStatusApi(data: integer[]): API.Res<QuerySupplierAddressRuleStatusResult> {
    return towerAftersaleRequest.post('/address/rule/querySupplierPushAddressStatus', { data })
}

// 查询供应商推送地址库列表
/**
 * 查询供应商推送地址库列表
 */
export function pageSupplierReturnAddressApi(
    params: PageSupplierReturnAddressUsingGetParams
): API.Res<ReturnAddressVo[]> {
    return towerAftersaleRequest.get('/addresses/pageSupplierReturnAddress', { params })
}

// 供分销备注多级自动同步配置
/**
 * 供分销备注多级自动同步配置
 */
export function multiDisShareInfoConfigApi(data: MultiDisShareInfoConfigParam): API.Res<object> {
    return towerAftersaleRequest.post('/config/multiDisShareInfoConfig', { data })
}

// 查询供分销备注多级自动同步配置
/**
 * 查询供分销备注多级自动同步配置
 */
export function getMultiDisShareInfoConfigApi(params: GetMultiDisShareInfoConfigUsingGetParams): API.Res<boolean> {
    return towerAftersaleRequest.get('/config/getMultiDisShareInfoConfig', { params })
}

// 试算供应商推荐退货地址
/**
 * 试算供应商推荐退货地址
 */
export function budgetSupplierRecommendAddressApi(data: integer[]): API.Res<RecommendReturnAddressResult[]> {
    return towerAftersaleRequest.post('/address/rule/budgetSupplierRecommendAddress', { data })
}

// 查询我的分销商补发售后单推单配置
/**
 * 查询我的分销商补发售后单推单配置
 */
export function listSwitchApi(params: ListSwitchUsingGetParams): API.Res<UConfigSwitchResult[]> {
    return towerAftersaleRequest.get('/uconfigs/listSwitch', { params })
}

// 查询自己的分销商仅退款必传凭证开关
/**
 * 查询自己的分销商仅退款必传凭证开关
 */
export function getOwnDistRefundOnlyCertRequiredApi(
    params: GetOwnDistRefundOnlyCertRequiredUsingGetParams
): API.Res<boolean> {
    return towerAftersaleRequest.get('/config/getOwnDistRefundOnlyCertRequired', { params })
}

// 修改自己的分销商仅退款必传凭证开关
/**
 * 修改自己的分销商仅退款必传凭证开关
 */
export function editDistributorReissueVoucherSwitchApi(
    data: EditDistributorReissueVoucherSwitchParam
): API.Res<object> {
    return towerAftersaleRequest.post('/config/editOwnDistRefundOnlyCertReq', { data })
}

// 开关配置
/**
 * 开关配置
 */
export function switchApi(data: UConfigSwitchParam): API.Res<object> {
    return towerAftersaleRequest.post('/uconfigs/switch', { data })
}

// 查询供应商的分销商补发售后单推单配置
/**
 * 查询供应商的分销商补发售后单推单配置
 */
export function getDrpCoIdToSwitchApi(params: GetDrpCoIdToSwitchUsingGet1Params): API.Res<boolean> {
    return towerAftersaleRequest.get('/uconfigs/getDrpCoIdToSwitch', { params })
}

// 查询供应商的分销商仅退款必传凭证开关
/**
 * 查询供应商的分销商补发凭证必传开关
 */
export function getSupDistRefundOnlyCertRequiredApi(
    params: GetSupDistRefundOnlyCertRequiredUsingGetParams
): API.Res<boolean> {
    return towerAftersaleRequest.get('/config/getSupDistRefundOnlyCertRequired', { params })
}

// 查询策略下的店铺列表
/**
 * 查询策略下的店铺列表
 */
export function queryRuleShopListApi(params: QueryRuleShopListUsingGetParams): API.Res<QueryAddressRuleShopResult[]> {
    return towerAftersaleRequest.get('/address/rule/queryRuleShopList', { params })
}

// 刷新匹配店铺
/**
 * 刷新匹配店铺
 */
export function matchRuleShopApi(params: MatchRuleShopUsingGetParams): API.Res<boolean> {
    return towerAftersaleRequest.get('/address/rule/matchRuleShop', { params })
}

// 删除策略
/**
 * 删除策略
 */
export function deleteRuleApi(data: DeletedAddressRuleParam): API.Res<object> {
    return towerAftersaleRequest.post('/address/rule/deleteRule', { data })
}

// 启用策略
/**
 * 启用策略
 */
export function enableRuleApi(data: CreateAddressRuleParam): API.Res<object> {
    return towerAftersaleRequest.post('/address/rule/enableRule', { data })
}

// 查询“供应商售后地址同步给分销商”的开关状态
/**
 * queryAfterSaleAddressSyncSwitch
 */
export function queryAfterSaleAddressSyncSwitchApi(
    data: MySupplierSimpleParam
): API.Res<AfterSaleAddressSyncSwitchResult[]> {
    return drpRequest.post('/mySupplier/queryAfterSaleAddressSyncSwitch', { data })
}

// 修改策略-更新启用店铺
/**
 * 更新启用店铺
 */
export function updateApplyShopApi(data: UpdateApplyShopParam): API.Res<object> {
    return towerAftersaleRequest.post('/address/rule/updateApplyShop', { data })
}

// 查询售后更改记录
export function queryAfterSalesRule(params: any) {
    return towerAftersaleRequest.get('/address/rule/pageRuleLog', {
        params
    })
}

// 售后管理-查询分销商的售后订单列表
/**
 * 售后管理-查询分销商的售后订单列表
 */
export function queryDistributorAfterSales(data: DisAfterSaleQueryDTO): API.Res<DisSaleOrderVo[]> {
    return towerRequest.post('/after-sale/dis/page/list', { data })
}

// 查询自动化策略列表
/**
 * 查询自动化策略列表
 */
export function queryPolicyList(params: ListUsingGetParams): API.Res<PageAutoRuleResult[]> {
    return towerAftersaleRequest.get('/automation/list', { params })
}

// 获取仓主coId
export function getWmsOwnerCoId() {
    return companyRequest.get('/wms/qimen/getWmsOwnerCoId')
}
// 查询自动化策略列表
export function queryWmsShowEnable() {
    return companyRequest.get('/wms/qimen/show/enable')
}

// 创建自动化规则
/**
 * 创建自动化规则V2
 */
export function createPolicyApiV2(data: CreateAfterSaleAutoRuleParam): API.Res<AutoRuleSaveResult> {
    return towerAftersaleRequest.post('/automation/createV2', { data })
}

// 修改自动化规则
/**
 * 更新自动化规则V2
 */
export function editPolicyApiV2(data: UpdateAfterSaleAutoRuleParam): API.Res<object> {
    return towerAftersaleRequest.post('/automation/updateV2', { data })
}

// 检查店铺设置是否一致
/**
 * 检查店铺设置是否一致
 */
export function checkAgSettingConsistentApi(params: CheckAgSettingConsistentUsingGetParams): API.Res<AgSettingResult> {
    return towerAftersaleRequest.get('/automation/checkAgSettingConsistent', { params })
}

// 查询店铺所在策略
/**
 * 查询店铺所在策略
 */
export function getShopLocationRuleApi(params: GetShopLocationRuleUsingGetParams): API.Res<AgRuleResult[]> {
    return towerAftersaleRequest.get('/automation/getShopLocationRule', { params })
}

// 修改记录
/**
 * list
 */
export function editPolicyLogApi(params: ListUsingGet1Params): API.Res<ListRuleLogResult[]> {
    return towerAftersaleRequest.get('/logs/automation/list', { params })
}

// 获取自动化规则详情
/**
 * 加载规则详情
 */
export function policyLoadApi(params: LoadUsingGetParams): API.Res<LoadAfterSaleAutoRuleResult> {
    return towerAftersaleRequest.get('/automation/load', { params })
}

/** 查询规则默认配置接口 */
/**
 * 获取默认自动化规则配置
 */
export function getDefaultRuleConfigurationApi(
    params: GetDefaultRuleConfigurationUsingGetParams
): API.Res<LoadAfterSaleAutoRuleResult> {
    return towerAftersaleRequest.get('/automation/getDefaultRuleConfiguration', { params })
}

// 获取自动化规则详情
/**
 * 是否存在权限供应商
 */
export function hasAllPushToSupplierRuleApi(params: HasAllPushToSupplierRuleUsingGetParams): API.Res<boolean> {
    return towerAftersaleRequest.get('/automation/hasAllPushToSupplierRule', { params })
}

// 修改策略启用状态V2
/**
 * 修改策略启用状态V2
 */
export function updatePolicyEnableV2(data: ChangeEnableParam): API.Res<object> {
    return towerAftersaleRequest.post('/automation/changeEnableV2', { data })
}

// 验证策略
/**
 * 验证策略
 */
export function verificationRuleApi(data: VerificationRuleParam): API.Res<SuccessFailResult> {
    return towerAftersaleRequest.post('/automation/verificationRule', { data })
}

// 删除自动化规则
/**
 * 删除自动化规则V2
 */
export function delPolicyApiV2(data: DeleteAfterSaleAutoRuleParam): API.Res<object> {
    return towerAftersaleRequest.post('/automation/deleteV2', { data })
}

// 查询自动化店铺
/**
 * 售后自动化店铺查询
 */
export function queryAutomationShops(params: ListShopAfterSaleAutoUsingGetParams): API.Res<ShopAfterSaleAutoVo[]> {
    return companyRequest.get('/shop/afterSale/auto/shop', { params })
}

// 售后自动化根据策略搜索店铺选择
/**
 * 售后自动化根据策略搜索店铺选择
 */
export function queryAutoAuthShop(): API.Res<ShopVo[]> {
    return companyRequest.get('/shop/afterSale/auto/authShop')
}

// 售后自动化根据策略ID查询店铺
/**
 * 售后自动化根据策略ID查询店铺
 */
export function queryAutomationShopsbByID(
    params: ListShopNameAfterSaleAutoUsingGetParams
): API.Res<ShopAfterSaleAutoVo[]> {
    return companyRequest.get('/shop/afterSale/auto/shopName', { params })
}

// 售后自动化根据策略ID查询供应商
/**
 * 根据策略id查询供应商名称
 */
export function queryAutomationSupplierByID(
    params: ListSupplierNameAfterSaleAutoUsingGetParams
): API.Res<SupplierNameValueVo[]> {
    return drpRequest.get('/partner/channel/afterSale/auto/supplierNames', { params })
}

// 售后管理-分销售后【确认售后单】
/**
 * 售后管理-分销售后【确认售后单】
 */
export function confirmDisAfterSales(data: AfterSaleConfirmDTO): API.Res<ErpAfterSaleConfirmVO> {
    return companyRequest.post('/after-sale/supplier/confirm', { data })
}

// 售后管理-分销售后【拒绝售后单】
/**
 * 售后管理-分销售后【拒绝售后单】
 */
export function cancelDisAfterSales(data: AfterSaleConfirmDTO): API.Res<ErpAfterSaleActionResultVO> {
    return companyRequest.post('/after-sale/supplier/cancel', { data })
}

// 售后管理-分销售后【反作废】
/**
 * 售后单反作废
 */
export function unCancelDisAfterSales(data: UnCancelDTO): API.Res<ErpAfterSaleActionResultVO> {
    return companyRequest.post('/after-sale/supplier/unCancel', { data })
}

// 售后商品-查询商品信息
/**
 * 售后商品-根据订单id查询商品信息
 */
export function afterSaleGoodsApi(params: ListAfterSaleByOrderNoGoodsUsingGetParams): API.Res<ErpAfterSaleGoodsVo[]> {
    return companyRequest.get('/afterSale/goods', { params })
}

// 获取订单列表(简要信息)
/**
 * 全部订单简要信息
 */
export function acquireAllSimpleOrders(data: InnerOrderListParam): API.Res<SimpleOrderListView[]> {
    return towerRequest.post('/order/acquireAllSimpleOrders', { data })
}

/** 检测售后单是否已经退款 */
export interface DrpCheckRefundResult {
    /** 售后单号 */
    asId: string
    /** 是否已退款 */
    refund: boolean
}

/** 供应商退款金额 */
// export interface DrpRefundAmountResult {
//     /** 退款金额 */
//     amount: number

//     /** 售后单号 */
//     asId: number

//     /** 扣款金额（用户不在 `as.new.drp` 白名单时值为 `null`） */
//     deductionAmount: number | null

//     /** 是否线上退款 */
//     onlineRefund: boolean

//     /** 支付单号 */
//     outerPayId: string | null

//     /** 应退金额（用户不在 `as.new.drp` 白名单时值为 `null`） */
//     shouldRefundAmount: number | null

//     /** 退款状态 */
//     status: OrderRefundStatus
// }

/**
 * 查询供应商退款金额
 * @param data  { asIds: [] }
 * @returns {Promise<API.RootObject<DrpRefundAmountResult[]>>}
 */
/**
 * 查询供应商退款金额
 */
export function drpRefundAmountApi(data: string[]): API.Res<DrpRefundAmountResult[]> {
    return towerAftersaleRequest.post('/afterSales/drp/drpRefundAmount', { data })
}

/**
 * 检测售后单是否已经退款
 * @param data  { asIds: [] }
 */
export function checkAfterSalesRefundApi(data): Promise<API.Res<DrpCheckRefundResult[]>> {
    return payRequest.post('/prePay/checkAfterSalesRefund', { data })
}

/**
 * 查询分销商退款状态金额
 * @param data  { asIds: [] }
 * @returns {Promise<API.RootObject<DrpRefundAmountResult[]>>}
 */
/**
 * 查询分销商退款状态金额
 */
export function disRefundAmountApi(data: string[]): API.Res<DrpRefundAmountResult[]> {
    return towerAftersaleRequest.post('/afterSales/drp/disRefundAmount', { data })
}

// 售后商品-仓库查询
/**
 * 仓库查询
 */
export function arehousesApi(): API.Res<SelectItem[]> {
    return companyRequest.get('/afterSale/warehouses')
}

// 售后单编辑
/**
 * 售后单编辑
 */
export function updateAfterSaleApi(data: AfterSaleDTO): API.Res<object> {
    return companyRequest.post('/afterSale/update', { data })
}

// 查询我的分销商数量
/**
 * 查询我的分销商数量
 */
export function partnerChannelCountApi(params: MyChannelCountUsingGet1Params): API.Res<number> {
    return drpRequest.get('/myPartner/myChannelCount', { params })
}

// 查询我的供应商数量
/**
 * 查询我的供应商数量
 */
export function partnerSupplierCountApi(params: MySupplierCountUsingGet1Params): API.Res<number> {
    return drpRequest.get('/myPartner/mySupplierCount', { params })
}

// 查询订单下是否有售后单
/**
 * 售后管理-查询订单下是否有售后单
 */
export function orderExistAfterSaleApi(data: OrderAfterSaleDTO): API.Res<string[]> {
    return towerRequest.post('/after-sale/orderExistAfterSale', { data })
}

/**
 * 售后手工创建售后单
 */
export function afterSaleCreatApi(data: SelfCreateAfterSaleDTO): API.Res<AfterSaleSelfCreateVo> {
    return companyRequest.post('/afterSale/selfCreates', { data })
}

// 售后手工创建无信息售后单
/**
 * 售后手工创建无信息售后单
 */
export function creatNoInfoApi(data: SelfCreateNoInformationAfterSaleDTO): API.Res<AfterSaleSelfCreateVo> {
    return companyRequest.post('/afterSale/selfCreates/noInformation', { data })
}

/**
 * 售后商品-根据skuCode集合查询商品信息
 */
export function queryErpGoodsApi(data: AfterSaleRefundGoodsCodeDTO): API.Res<ErpAfterSaleGoodsVo[]> {
    return companyRequest.post('/afterSale/goods/skuCodes', { data })
}

// 售后管理-代发售后【极速退款】
/**
 * 售后管理-代发售后【极速退款】
 */
export function fastRefundApi(data: FastRefundDTO): API.Res<ErpAfterSaleActionResultVO> {
    return companyRequest.post('/after-sale/issuing/fast-refund', { data })
}

// 售后管理-代发售后【极速退款】校验上游是否已退款完成
/**
 * 校验供应商是否已退款完成
 */
export function checkSupplierRefundFinishApi(data: string[]): API.Res<CheckSupplierRefundFinishVo> {
    return companyRequest.post('/after-sale/issuing/checkSupplierRefundFinish', { data })
}
/**
 * 获取极速版归档配置及最新归档执行信息
 */
export function getLiteOrderArchiveInfoUsingPOST(): API.Res<LiteOrderArchiveInfoVO> {
    return companyRequest.post('/order/getLiteOrderArchiveInfo')
}

/**
 * 无信息件-从商品库添加退货商品
 */
export function queryErpGoodsNoInformationApi(data: AfterSaleNoInformationGoodsDTO): API.Res<ErpAfterSaleGoodsVo[]> {
    return companyRequest.post('/afterSale/goods/noInformation', { data })
}

/**
 * 售后商品-根据sku详情Id集合查询商品信息
 */
export function queryOrderGoodsApi(params: ListAfterSaleByIdsGoodsUsingGetParams): API.Res<ErpAfterSaleGoodsVo[]> {
    return companyRequest.get('/afterSale/goods/detailIds', { params })
}

/**
 * 售后管理-查询自动化结果
 */
export function autoRuleLogApi(params: GetAutoRuleLogUsingGetParams): API.Res<AfterSaleAutoRuleLogVo> {
    return companyRequest.get('/afterSale/logs/autoRule/log', { params })
}

/**
 * 无信息件-绑定订单查询商品详情
 */
export function noInfoGoodsDetail(
    data: QueryAfterSaleNoInformationGoodsDetailDTO
): API.Res<NoInformationBindOrderSkuVo[]> {
    return companyRequest.post('/afterSale/goods/noInformation/detail', { data })
}

// 无信息绑定订单
/**
 * 无信息绑定订单
 */
export function bindOrderApi(data: NoInformationBindOrderDTO): API.Res<AfterSaleNoInformationBindOrderVo> {
    return companyRequest.post('/afterSale/selfCreates/bindOrder', { data })
}

export interface QueryLogisticsStatusParams {
    /** 物流单号 */
    logisticsNo: string

    /** 创建时间 */
    createTime: string
}

/**
 * 批量查询物流状态 (转换包含中文无法完全转换)
 */
export function batchLogisticsStatusApi(data: QueryLogisticsStatusParams[]): API.Res<LogisticsStatusVo[]> {
    return companyRequest.post('/logistics/batchQueryLogisticsStatus', { data })
}

// 批量查询物流轨迹
/**
 * 批量查询物流轨迹
 */
export function batchLogisticsTrailApi(data: string[]): API.Res<LogisticsTrailVo[]> {
    return companyRequest.post('/logistics/batchLogisticsTrail', { data })
}

//
// 售后单状态反确认
/**
 * 售后管理-分销售后【取消售后单】
 */
export function afterSaleUnConfirm(data: UnConfirmDTO): API.Res<ErpAfterSaleActionResultVO> {
    return companyRequest.post('/after-sale/supplier/unConfirm', { data })
}

// 图片编辑
/**
 * 图片编辑
 */
export function afterSaleImagesUpdate(data: ImageUpdateDTO): API.Res<object> {
    return companyRequest.post('/afterSale/images/update', { data })
}

// 图片编辑
/**
 * 图片查询
 */
export function afterSaleImages(data: string[]): API.Res<AfterSaleImage[]> {
    return companyRequest.post('/afterSale/images', { data })
}

// 共享信息查询
/**
 * 查询共享信息
 */
export function afterSaleShareInfos(data: integer[]): API.Res<ShareInfoResult[]> {
    return towerAftersaleRequest.post('/share/list', { data })
}

// 查询分销预付费订单的发货倒计时信息
/**
 * 查询分销预付费订单的发货倒计时信息 (转换包含中文无法完全转换)
 */
export function queryDisPrepaidDeliveryCountDownApi(data: any): API.Res<OrderDisSendVo[]> {
    return towerRequest.post('/innerOrder/queryDisPrepaidDeliveryCountDown', { data })
}

// 查询补发-换货 获取售后订单处理进度
/**
 * 批量获取售后订单处理进度 (转换包含中文无法完全转换)
 */
export function reissueExchangeOidApi(data: string[]): API.Res<any[]> {
    return towerAftersaleRequest.post('/orders/queryAfterSalesOrderProgress', { data })
}

// 查询补发-换货 获取售后订单处理进度 详情
/**
 * 获取售后订单处理进度 (转换包含中文无法完全转换)
 */
export function queryAfterSalesOrderProgressDetail(
    params: QueryAfterSalesOrderProgressDetailUsingGetParams
): API.Res<any> {
    return towerAftersaleRequest.get('/orders/queryAfterSalesOrderProgressDetail', { params })
}

// 查询供应商物流信息
/**
 * 查询供应商物流信息
 */
export function querySupplierLogisticsTrackInfoApi(
    params: QuerySupplierLogisticsTrackInfoUsingGetParams
): API.Res<SupplierLogisticsTrackInfoVo[]> {
    return towerAftersaleRequest.get('/afterSales/drp/querySupplierLogisticsTrackInfo', { params })
}

// 查询供应商售后单操作时间
/**
 * 查询供应商售后单操作时间
 */
export function statusOperationLogApi(data: string[]): API.Res<OperationLogResult[]> {
    return towerAftersaleRequest.post('/afterSales/drp/statusOperationLog', { data })
}

/** 查询自己的退款规则 */
export function queryOwnRefundRuleApi(params: QueryOwnRefundRuleUsingGetParams): API.Res<AfterSaleRefundRuleVo> {
    return towerAftersaleRequest.get('/afterSales/refund/queryOwnRefundRule', { params })
}

/** 修改售后无忧退开关 */
export function editHassleFreeRefundToggle(data) {
    return drpRequest.post('/config/editHassleFreeRefundToggle', { data })
}

/** 查询售后无忧退开关 */
export function queryHassleFreeRefundToggle() {
    return drpRequest.get('/config/queryHassleFreeRefundToggle')
}

/** 保存或跟新退款规则 */
/**
 * 保存或更新退款规则
 */
export function saveOrUpdateRefundRuleApi(data: SaveRefundRuleParam): API.Res<boolean> {
    return towerAftersaleRequest.post('/afterSales/refund/saveOrUpdateRefundRule', { data })
}

/** 查询供应商的退款规则 */
/**
 * 查询供应商的退款规则
 */
export function querySupplierRefundRuleApi(
    params: QuerySupplierRefundRuleUsingGetParams
): API.Res<AfterSaleRefundRuleVo> {
    return towerAftersaleRequest.get('/afterSales/refund/querySupplierRefundRule', { params })
}

/** 查询有退款规则的供应商 */
/**
 * 查询有退款规则的供应商
 */
export function queryPreSuppliersWithRefundRulesApi(
    data: QueryPreSuppliersWithRefundRulesParam
): API.Res<QueryPreSuppliersWithRefundRulesVo> {
    return towerAftersaleRequest.post('/afterSales/refund/queryPreSuppliersWithRefundRules', { data })
}

/** 查询供应商是否设置了退款规则 */
/**
 * 查询供应商是否设置了退款规则
 */
export function checkIfSupplierHasSetRefundRuleApi(
    params: CheckIfSupplierHasSetRefundRuleUsingGetParams
): API.Res<boolean> {
    return towerAftersaleRequest.get('/afterSales/refund/checkIfSupplierHasSetRefundRule', { params })
}

/** 查询有退款规则的供应商 */
/**
 * 查询有退款规则的供应商
 */
export function querySuppliersWithRefundRulesApi(data: QuerySuppliersWithRefundRuleParam): API.Res<int[]> {
    return towerAftersaleRequest.post('/afterSales/refund/querySuppliersWithRefundRules', { data })
}

/** 根据订单号查询是否设置了退款规则 */
/**
 * 根据订单号查询是否设置了退款规则
 */
export function hasRefundRuleByOrderIdApi(data: HasRefundRuleByOrderIdParam): API.Res<HasRefundRuleByOrderIdVo> {
    return towerAftersaleRequest.post('/afterSales/refund/hasRefundRuleByOrderId', { data })
}

/** 查询自己是否设置了退款规则 */
/**
 * 查询自己是否设置了退款规则
 */
export function checkIfUserHasSetRefundRuleApi(params: CheckIfUserHasSetRefundRuleUsingGetParams): API.Res<boolean> {
    return towerAftersaleRequest.get('/afterSales/refund/checkIfUserHasSetRefundRule', { params })
}

/** 售后规则操作日志查询 */
/**
 * 售后规则操作日志查询
 */
export function queryRuleLogApi(data: QueryRuleLogParam): API.Res<AfterSaleRuleLogVoObject[]> {
    return towerAftersaleRequest.post('/rule/log/queryRuleLog', { data })
}

// 批量修改售后单退款金额
/**
 * 批量修改售后单退款金额 (转换包含中文无法完全转换)
 */
export function batchUpdateRefundAmountApi(data: any): API.Res<BatchUpdateRefundAmountVo> {
    return towerAftersaleRequest.post('/afterSales/drp/batchUpdateRefundAmount', { data })
}

// 售后单是否允许修改退款金额
/**
 * 售后单是否允许修改退款金额
 */
export function isRefundAmountModificationAllowedApi(data: string[]): API.Res<boolean> {
    return towerAftersaleRequest.post('/afterSales/drp/isRefundAmountModificationAllowed', { data })
}

// 售后单取消异常
/**
 * 售后异常取消
 */
export function cancelExceptionApi(data: CancelExceptionDTO): API.Res<ErpAfterSaleActionResultVO> {
    return companyRequest.post('/after-sale/supplier/cancelException', { data })
}

// 共享信息保存
/**
 * 共享信息保存
 */
export function afterSaleShareInfoSave(data: ShareInfoDTO): API.Res<object> {
    return companyRequest.post('/afterSale/shareInfos/save', { data })
}

// 共享信息修改
/**
 * 共享信息修改
 */
export function afterSaleShareInfoUpdate(data: ShareInfoDTO): API.Res<object> {
    return companyRequest.post('/afterSale/shareInfos/update', { data })
}

// 批量更新新增共享信息
/**
 * 批量更新新增共享信息
 */
export function batchUpsertShareApi(data: BatchUpsertShareParam): API.Res<object> {
    return towerAftersaleRequest.post('/share/batchUpsertShare', { data })
}

// 批量更新新增共享信息
/**
 * 批量更新新增共享信息V2
 */
export function batchUpsertShareV2Api(data: BatchUpsertShareParam): API.Res<object> {
    return towerAftersaleRequest.post('/share/batchUpsertShareV2', { data })
}

// 是否有共享信息
/**
 * 是否有共享信息
 */
export function hasShareInfoApi(params: HasShareInfoUsingGetParams): API.Res<HasShareInfoVO> {
    return companyRequest.get('/afterSale/shareInfos/hasShareInfo', { params })
}

/**
 * 统计自动化策略数量
 */
export function getAutoPolicyCountApi(params: CountUsingGetParams): API.Res<number> {
    return towerAftersaleRequest.get('/automation/count', { params })
}

// 查询标记|线下备注配置
/**
 * 查询标记|线下备注配置
 */
export function configsNode(): API.Res<string[]> {
    return companyRequest.get('/afterSale/configs/node')
}

// 保存标记|线下备注配置
/**
 * 保存标记|线下备注配置
 */
export function saveConfigsNode(data: ConfigOfflineNoteDTO): API.Res<string[]> {
    return companyRequest.post('/afterSale/configs/node', { data })
}

// 绑定线下标记备注
/**
 * 绑定线下标记备注
 */
export function bindNote(data: BindOfflineNoteDTO): API.Res<AfterSaleBindOfflineNoteVo> {
    return companyRequest.post('/afterSale/bindNote', { data })
}

// 查询备注模版
/**
 * 查询备注模版
 */
export function getNoteTemplate(params: GetNoteTemplateUsingGetParams): API.Res<AfterSaleNoteTemplateResult> {
    return towerAftersaleRequest.get('/config/node/template', { params })
}

// 备注模版保存
/**
 * 备注模版保存
 */
export function updateNoteTemplate(data: AfterSaleNoteTemplateDTO): API.Res<object> {
    return companyRequest.post('/afterSale/configs/node/template', { data })
}

// 售后管理-查询备注模版
/**
 * 查询备注模版日志
 */
export function getTemplateLog(params: GetExportResultUsingGetParams): API.Res<NoteTemplateLogResult[]> {
    return towerAftersaleRequest.get('/logs/note/templateLog', { params })
}

// 售后管理-原订单金额
/**
 * 订单金额
 */
export function getOrderAmount(data: string): API.Res<OrderToAfterSaleAmountVo> {
    return companyRequest.post('/order/afterSale/amount', { data })
}

// 查询待授权的分销商数据
/**
 * 查询待授权的分销商数据
 */
export function queryWaitAuthChannel(): API.Res<WaitAuthChannelVo[]> {
    return drpRequest.get('/myPartner/queryWaitAuthChannel')
}

// 售后自动化 供应商列表
/**
 * 售后自动化 供应商列表
 */
export function queryAutoSuppliers(
    params: ListSuppliersAfterSaleAutoUsingGetParams
): API.Res<SupplierAfterSaleAutoVo[]> {
    return drpRequest.get('/partner/channel/afterSale/auto/suppliers', { params })
}

// 售后自动化策略 查询三方仓列表
/**
 * 获取勾选的三方仓列表 (转换包含中文无法完全转换)
 */
export function querySelectedThirdPartyWarehousesApi(
    params: QuerySelectedThirdPartyWarehousesUsingGetParams
): API.Res<any[]> {
    return towerAftersaleRequest.get('/automation/querySelectedThirdPartyWarehouses', { params })
}

// 售后自动化列表查询 查询三方仓列表
/**
 * 查询三方仓列表 (转换包含中文无法完全转换)
 */
export function queryThirdWarehouseListApi(params: QueryThirdWarehouseListUsingGetParams): API.Res<any[]> {
    return towerAftersaleRequest.get('/automation/queryThirdWarehouseList', { params })
}

// 售后自动化根据策略ID查询第三方仓
/**
 * 售后自动化根据策略ID查询三方仓 (转换包含中文无法完全转换)
 */
export function queryThirdWarehouseByAutoRuleIdApi(
    params: QueryThirdWarehouseByAutoRuleIdUsingGetParams
): API.Res<any[]> {
    return towerAftersaleRequest.get('/automation/queryThirdWarehouseByAutoRuleId', { params })
}

// 查询待授权的供应商数据
/**
 * 查询待授权的供应商数据
 */
export function queryWaitAuthSupplier(): API.Res<WaitAuthSupplierVo[]> {
    return drpRequest.get('/myPartner/queryWaitAuthSupplier')
}
/**
 * 查询待授权的供应商数据分页
 */
export function queryMyWaitAuthSuppliersApi(params): API.Res<WaitAuthSupplierVo[]> {
    return drpRequest.get('/mySupplier/queryMyWaitAuthSuppliers', { params })
}
/**
 * 查询已确认的供应商数据
 */
export function queryMyConfirmedSuppliersApi(params): API.Res<WaitAuthSupplierVo[]> {
    return drpRequest.get('/mySupplier/queryMyConfirmedSuppliers', { params })
}

// 寻合作找分销商时批量撤回申请
/**
 * 寻合作找分销商时批量撤回申请
 */
export function batchRevokeApplyBySupplier(data: BatchRevokeApplyParam): API.Res<null> {
    return drpRequest.post('/myPartner/batchRevokeApplyBySupplier', { data })
}

// 寻合作找供应商时批量撤回申请
/**
 * 寻合作找供应商时批量撤回申请
 */
export function batchRevokeApplyByChannel(data: BatchRevokeApplyParam): API.Res<null> {
    return drpRequest.post('/myPartner/batchRevokeApplyByChannel', { data })
}

// 查询我的分销商数量
/**
 * 查询我的待授权分销商数量
 */
export function waitAuthChannelCount(): API.Res<number> {
    return drpRequest.get('/myPartner/waitAuthChannelCount')
}

// 查询供应商退款状态选项
export function querySupplierRefundStatus() {
    return securityRequest.get('/security/configV2/find?key=AFTER_SALE_REFUND_STATUS')
}

// 异常枚举字典查询接口
/**
 * 查询售后单异常类型
 */
export function queryAfterSalesExceptionTypeApi(): API.Res<AfterSalesExceptionVo[]> {
    return companyRequest.get('/afterSale/dictionaries/queryAfterSalesExceptionType')
}

// 查询售后标签列表
/**
 * 查询售后标签列表
 */
export function queryAfterSalesLabelListApi(): API.Res<QueryAfterSalesLabelListVo> {
    return companyRequest.get('/afterSale/dictionaries/queryAfterSalesLabelList')
}

// 新增/删除商家自定义标签
/**
 * 保存售后标签
 */
export function saveAfterSalesLabelApi(data: SaveAfterSalesLabelDTO): API.Res<SaveAfterSalesLabelVo> {
    return companyRequest.post('/afterSale/dictionaries/saveAfterSalesLabel', { data })
}

// 给售后单设置标签
/**
 * 给售后单设置标签
 */
export function setLabelToAfterSalesOrderApi(data: SetLabelToAfterSalesOrderDTO): API.Res<SetLabelToAfterSalesOrderVo> {
    return companyRequest.post('/afterSale/setLabelToAfterSalesOrder', { data })
}

// 保存退货地址
/**
 * 保存退货地址
 */
export function saveAddress(data: AfterSaleReturnAddressParam): API.Res<null> {
    return towerAftersaleRequest.post('/addresses/save', { data })
}

// 修改退货地址
/**
 * 修改退货地址
 */
export function updateAddress(data: AfterSaleReturnAddressParam): API.Res<null> {
    return towerAftersaleRequest.post('/addresses/update', { data })
}

// 启用进度查询
/**
 * 启用进度查询
 */
export function enableRuleProcess(params: EnableRuleProcessUsingGetParams): API.Res<EnableRuleProcessResult> {
    return towerAftersaleRequest.get('/address/rule/enableRuleProcess', { params })
}

// 修改免责申明
/**
 * 修改免责申明
 */
export function updateDisclaimer(data: DisclaimerVo): API.Res<null> {
    return drpRequest.post('/company/updateDisclaimer', { data })
}

// 查询线上订单号下符合要求的售后单数量
/**
 * 查询线上订单号下符合要求的售后单数量
 */
export function afterSalesOrderStatisticsBySoId(data: string[]): API.Res<AfterSaleOrderStatisticsBySoIdResult[]> {
    return towerAftersaleRequest.post('/afterSales/order/statistics/bySoId', { data })
}

// 查询退款是否发送短信
/**
 * 查询退款是否发送短信
 */
export function getIgnoreSmsCodeApi(params: GetIgnoreSmsCodeUsingGetParams): API.Res<boolean> {
    return towerAftersaleRequest.get('/uconfigs/getIgnoreSmsCode', { params })
}

/**
 * 查询自己的退货地址详情
 */
export function loadReturnAddress(params: LoadReturnAddressUsingGetParams): API.Res<LoadReturnAddressResult> {
    return towerAftersaleRequest.get('/addresses/loadReturnAddress', { params })
}

// 查询所有售后问题类型列表
/**
 * 查询所有售后问题类型列表
 */
export function listAllAfterSaleQuestion(
    params: ListAllAfterSaleQuestionUsingGetParams
): API.Res<ListAllAfterSaleQuestionResult[]> {
    return towerAftersaleRequest.get('/config/listAllAfterSaleQuestion', { params })
}

// 保存售后问题类型
/**
 * 保存售后问题类型
 */
export function saveAfterSaleQuestion(data: SaveAfterSaleQuestionParam): API.Res<object> {
    return towerAftersaleRequest.post('/config/saveAfterSaleQuestion', { data })
}

// 查询ag拦截设置规则
/**
 * 查询ag拦截设置规则
 */
export function findInterceptSetting(params: FindInterceptSettingUsingGetParams): API.Res<FindInterceptSettingResult> {
    return towerAftersaleRequest.get('/agSetting/findInterceptSetting', { params })
}

// 修改ag拦截设置
/**
 * 修改拦截设置
 */
export function modifyInterceptSetting(data: ModifyInterceptSettingParam): API.Res<object> {
    return towerAftersaleRequest.post('/agSetting/modifyInterceptSetting', { data })
}

// 查询订单状态
/**
 * 查询订单状态
 */
export function agSettingQueryOrderStatus(params: QueryOrderStatusUsingGetParams): API.Res<QueryOrderStatusResult[]> {
    return towerAftersaleRequest.get('/agSetting/queryOrderStatus', { params })
}

// 导出已拦截的单子
/**
 * 导出已拦截的单子
 */
export function afterSalesExport1(data: AlreadyInterceptionOrderQueryParam): API.Res<string> {
    return towerAftersaleRequest.post('/logisticsInterceptions/export', { data })
}

// 导出待拦截的单子
/**
 * 导出待拦截的单子
 */
export function afterSalesExport2(data: WaitInterceptionOrderQueryParam1): API.Res<string> {
    return towerAftersaleRequest.post('/logisticsInterceptions/wait/export', { data })
}

// 导出结果
/**
 * 导出结果
 */
export function exportResult(params: ResultUsingGetParams): API.Res<string> {
    return towerAftersaleRequest.get('/afterSales/export/result', { params })
}

/**
 * 查询我的供应商下拉列表使用
 * @param data
 * @returns
 */
/**
 * 查询我的供应商下拉列表使用
 */
export function mySupplierForSelect(data: SimplePartnerParam): API.Res<SimplePartnerVo[]> {
    return drpRequest.post('/partner/channel/mySupplierForSelect', { data })
}

/**
 * 查询我的分销商下拉列表使用
 * @param data
 * @returns
 */
/**
 * 查询我的分销商下拉列表使用
 */
export function myChannelForSelect(data: SimplePartnerParam): API.Res<SimplePartnerVo[]> {
    return drpRequest.post('/partner/supplier/myChannelForSelect', { data })
}

/**
 * 查询售后结果列表
 * @param params
 * @returns
 */
/**
 * 查询售后结果列表 (转换包含中文无法完全转换)
 */
export function getProcessResult(params: GetProcessResultUsingGetParams): API.Res<any[]> {
    return towerAftersaleRequest.get('/config/getProcessResult', { params })
}

/**
 * 批量跟新售后单处理状态
 * @param data
 * @returns
 */
/**
 * 批量跟新售后单处理状态 (转换包含中文无法完全转换)
 */
export function updateProcessResult(data: any): API.Res<UpdateProcessResultResp> {
    return towerAftersaleRequest.post('/afterSales/drp/updateProcessResult', { data })
}

/**
 * 查询售后打印设置
 * @param 打印模版类型 打印吊牌：PRINT_TAG 打印条形码：PRINT_BARCODE,可用值:PRINT_TAG,PRINT_BARCODE
 * @returns
 */
/**
 * 查询售后打印设置 (转换包含中文无法完全转换)
 */
export function queryAfterSalesOrderPrintSetting(
    params: QueryAfterSalesOrderPrintSettingUsingGetParams
): API.Res<any[]> {
    return towerAftersaleRequest.get('/print/queryAfterSalesOrderPrintSetting', { params })
}

/**
 * 保存售后打印设置
 * @param data
 * @returns
 */
/**
 * 保存售后打印设置 (转换包含中文无法完全转换)
 */
export function saveAfterSalesOrderPrintSetting(data: any): API.Res<boolean> {
    return towerAftersaleRequest.post('/print/saveAfterSalesOrderPrintSetting', { data })
}

interface PrintCount {
    printCount: number
    skuId: string
}

interface AfterSalesOrderPrintCountRes {
    printInfos: PrintCount[]
}

/**
 * 获取售后单打印数量
 * @param data
 * @returns
 */
export const getAfterSalesOrderPrintCount = ({
    asIds,
    printQuantityStrategy
}: {
    asIds: string[]
    printQuantityStrategy: ReturnQuantityType
}): Promise<API.RootObject<AfterSalesOrderPrintCountRes[]>> => {
    return towerAftersaleRequest.post('/print/getAfterSalesOrderPrintCount', { data: { asIds, printQuantityStrategy } })
}

/**
 * 保存售后结果列表
 * @param data
 * @returns
 */
/**
 * 保存售后结果列表 (转换包含中文无法完全转换)
 */
export function saveProcessResult(data: any): API.Res<boolean> {
    return towerAftersaleRequest.post('/config/saveProcessResult', { data })
}

/**
 * 同步供应商退货地址
 * @param data
 * @returns
 */
/**
 * 手动同步退货地址
 */
export function syncReturnAddress(data: AfterSaleSyncReturnAddressParam): API.Res<null> {
    return towerAftersaleRequest.post('/addresses/syncReturnAddress', { data })
}

/**
 * 用户是否有奇门权限，场景：用于售后管理的推送奇门云仓权限
 */
export const getWmsQimenEnable = () => {
    return companyRequest.get('/wms/qimen/show/enable')
}

/**
 * 售后管推送回奇门云仓
 */
export const pushQimenFromAfterSale = (asIds: string[]) => {
    return companyRequest.post('/after-sale/qimen/sync', { data: { asIds } })
}

/**
 * 售后管理撤回奇门云仓
 */
export const revokeQimenFromAfterSale = (asIds: string[]) => {
    return companyRequest.post('/after-sale/qimen/revocation', { data: { asIds } })
}

// 获取商品明细集合
/**
 * 获取商品明细集合
 */
export function getAfterSalesItemGoodsList(
    params: ListAfterSaleGoodsDetailUsingGetParams
): API.Res<AfterSaleItemInfoVO[]> {
    return companyRequest.get('/afterSale/goods/item/list', { params })
}

// 从商品库新增售后商品
/**
 * 从商品库新增售后商品
 */
export function addAfterGoodsByGoodsLib(data: AfterSaleRefundGoodsCodeDTO): API.Res<AfterSaleItemInfoVO[]> {
    return companyRequest.post('/afterSale/goods/add-for-goods', { data })
}

// 从订单新增售后商品
/**
 * 从订单新增售后商品
 */
export function addAfterGoodsByOrder(data: AfterSaleRefundGoodsCodeDTO): API.Res<AfterSaleItemInfoVO[]> {
    return companyRequest.post('/afterSale/goods/add-for-order', { data })
}

// 更新售后商品
/**
 * 更新售后商品
 */
export function updateAfterSaleGoods(data: AfterSaleGoodsUpdateDTO): API.Res<string> {
    return companyRequest.post('/afterSale/goods/update', { data })
}

// 获取是否存在视频监控信息列表
/**
 * 获取是否存在视频监控信息列表
 */
export function afterSaleIpcHasVideo(data: List<Long>): API.Res<long[]> {
    return companyRequest.post('/after-sale/ipc/has-video', { data })
}

// 根据售后单Id获取视频监控信息
/**
 * 根据售后单Id获取视频监控信息
 */
export function afterSaleIpcGetVideoList(
    params: GetVideoMonitorInfoByAsIdUsingGetParams
): API.Res<VideoMonitorInfoVo[]> {
    return companyRequest.get('/after-sale/ipc/get-video-list', { params })
}

// 获取视频数据信息
/**
 * 获取视频数据信息 (转换包含中文无法完全转换)
 */
export function getDownloadIpcVideo(data: VideoDataInfoDTO): API.Res<any> {
    return companyRequest.post('/after-sale/ipc/get-video-data', { data })
}

// 删除售后商品
/**
 * 删除售后商品
 */
export function deleteAfterSaleGoods(data: AfterSaleGoodsDelDTO): API.Res<string> {
    return companyRequest.post('/afterSale/goods/delete', { data })
}

// 原退原换
/**
 * 原退原换
 */
export function originalReturnExchange(data: AfterSaleItemInfoVO1): API.Res<AfterSaleItemInfoVO[]> {
    return companyRequest.post('/afterSale/goods/original-return-exchange', { data })
}

export interface QueryRefundClientCountParams {
    /**
     * 是否使用缓存
     * @default false
     */
    cacheEnable?: boolean
}

/** 统计有待退款单的分销商总数 */
export function queryRefundedClientCount(payload: QueryRefundClientCountParams): API.Res<{ count: number }> {
    return companyRequest.get('/afterSale/statistics/dis/queryRefundedClientCount', { params: payload })
}

export interface QueryRefundSupplierCountParams {
    /**
     * 是否使用缓存
     * @default false
     */
    cacheEnable?: boolean
}

/** 统计有待退款单的供应商总数 */
export function queryRefundedSupplierCount(payload: QueryRefundSupplierCountParams): API.Res<{ count: number }> {
    return companyRequest.get('/afterSale/statistics/supplier/queryRefundedClientCount', { params: payload })
}

export enum QueryRefundStatisticsType {
    /** 供应商 */
    SUPPLIER = 'SUPPLIER',

    /** 分销商 */
    CHANNEL = 'CHANNEL'
}

export interface QueryRefundStatisticsParam {
    /** 是否使用缓存 */
    cacheEnable: boolean

    /** 客户coid集合 */
    coIds: string[]

    /** SUPPLIE-供应商 CHANNEL-分销商 */
    type: QueryRefundStatisticsType
}

export interface RefundStatistic {
    /** 分销/供销 coid */
    coId: string

    /**
     * 分销+待退款单量
     * `type = SUPPLIE` 时为 分销售后单量
     * `type = CHANNEL` 时为 供应商已确认待退款单量
     */
    drpCount: number

    /**
     * 中间商待退款单量
     * `type = SUPPLIE` 时为 二级分销售后单量
     * `type = CHANNEL` 时为 自己已确认待退款单量
     */
    midCount: number
}

export interface QueryRefundStatisticsResult {
    refundStatistics: RefundStatistic[]
}

/** 查询指定分销-供销待退款单量 */
export function queryRefundStatistics(data: QueryRefundStatisticsParam): API.Res<QueryRefundStatisticsResult> {
    return companyRequest.post('/afterSale/statistics/queryRefundStatistics', { data })
}

/** 售后管理-售后订单列表-简略版 */
/**
 * 售后管理-查询分销商的售后订单列表-简略版
 */
export function simpleList(data: DisAfterSaleQueryDTO): API.Res<DisSaleOrderVo[]> {
    return towerRequest.post('/after-sale/page/list/simple', { data })
}

/**
 * 查询订单简要信息
 */
export function queryOrderSimpleInfoUsingPOST(data: QueryOrderSoIdParam): API.Res<OrderBriefInfoVo[]> {
    return towerRequest.post('/innerOrder/queryOrderSimpleInfo', { data })
}

/**
 * queryExpressTotalConfig
 * 售后管理-快递单号查询限制优化
 */

export function queryExpressTotalConfigUsingPOST(data: CurrentUser): API.Res<number> {
    return towerRequest.post('/config/user/expressTotal/config', { data })
}

/**
 * 试算供应商推荐退货地址V2 (转换包含中文无法完全转换)
 */
export function trialSupplierRecommendAddressV2UsingPOST(data: any): API.Res<RecommendReturnAddressResult[]> {
    return towerAftersaleRequest.post('/address/rule/trialSupplierRecommendAddressV2', { data })
}

/**
 * 地址匹配
 */
export function shopAddressMatchUsingPOST(
    data: MultilevelShopAddressMatchParam[]
): API.Res<MultilevelShopAddressMatchVo[]> {
    return towerAftersaleRequest.post('/addresses/shopAddressMatch', { data })
}

/**
 * 创建店铺地址接口
 */
export function createShopAddressUsingPOST(data: MultilevelShopAddressParam): API.Res<MultilevelShopAddressVo> {
    return towerAftersaleRequest.post('/addresses/createShopAddress', { data })
}

/** 查询店铺地址列表 */
export function queryShopAddressList(data: QueryShopAddressListParam): API.Res<QueryShopAddressListVO[]> {
    return towerAftersaleRequest.post('/addresses/queryShopAddressList', { data })
}

/** 查询基础地址列表 */
export function queryBaseAddressList(data: any): API.Res {
    return towerAftersaleRequest.post('/addresses/queryBaseAddressList', { data })
}

/** 查询发货仓地址列表 */
export function queryShippingWarehouseAddressList(params: any): API.Res {
    return towerAftersaleRequest.get('/addresses/queryDeliveryWarehouseAddress', { params })
}

/** 查询供应商退货地址列表(合作中) */
export function querySupplierReturnAddressList(data: any): API.Res {
    return towerAftersaleRequest.post('/addresses/querySupplierReturnAddress', { data })
}

/** 删除基础退货地址 */
export function deleteBaseAddress(data: DeleteBaseAddressParam): API.Res<boolean> {
    return towerAftersaleRequest.post('/addresses/deleteBaseAddress', { data })
}

/** 新增店铺地址 */
export function saveShopAddress(data: CreateShopAddressParam): API.Res<UpdateShopAddressVO> {
    return towerAftersaleRequest.post('/addresses/saveShopAddress', { data })
}

/** 店铺地址删除 */
export function deleteShopAddress(data: RemoveShopAddressParam): API.Res<null> {
    return towerAftersaleRequest.post('/addresses/deleteShopAddress', { data })
}

/** 店铺地址修改 */
export function updateShopAddress(data: UpdateShopAddressParam): API.Res<null> {
    return towerAftersaleRequest.post('/addresses/updateShopAddress', { data })
}

/** 批量店铺地址修改 */
export function batchUpdateShopAddress(data: BatchUpdateShopAddressParam): API.Res<UpdateShopAddressVO> {
    return towerAftersaleRequest.post('/addresses/batchUpdateShopAddress', { data })
}

/** 批量店铺地址删除 */
export function batchDeleteShopAddress(data: BatchRemoveShopAddressParam): API.Res<UpdateShopAddressVO> {
    return towerAftersaleRequest.post('/addresses/batchDeleteShopAddress', { data })
}

/** 下载更新店铺后台地址 (转换包含中文无法完全转换) */
export function downloadShopAddressUsingPOST(data: any): API.Res<any> {
    return towerAftersaleRequest.post('/addresses/downloadShopAddress', { data })
}

/** 获取任务进度 */
export function getTaskProgress(params: GetTaskProgressUsingGetParams): API.Res<AsyncProcessingResultVoObject> {
    return towerAftersaleRequest.get('/async/task/getTaskProgress', { params })
}

/** 地址解密 */
export function decryptAddress(params: DecryptAddressUsingGetParams): API.Res<LoadReturnAddressResult> {
    return towerAftersaleRequest.get('/addresses/decryptAddress', { params })
}

/** 检查地址是否一致 */
export function equalsAddress(data: EqualsAddressParam): API.Res<EqualsAddressVO> {
    return towerAftersaleRequest.post('/addresses/equalsAddress', { data })
}

/** 根据店铺ID批量查询地址数量 */
export function queryShopAddressByIds(data: QueryShopAddressNumByIdsParam): API.Res<QueryShopAddressNumByIdsVO[]> {
    return towerAftersaleRequest.post('/addresses/queryShopAddressByIds', { data })
}

/** 查询售后退货地址日志 */
export function queryReturnAddressLogs(
    params: QueryReturnAddressLogsUsingGetParams
): API.Res<ReturnAddressChangeLogVo[]> {
    return towerAftersaleRequest.get('/logs/automation/queryReturnAddressLogs', { params })
}

/** 批量保存供应商/发货仓地址 (转换包含中文无法完全转换) */
export function batchSaveBaseAddress(data: any): API.Res<boolean> {
    return towerAftersaleRequest.post('/addresses/batchSaveBaseAddress', { data })
}

/** 检测供应商/发货仓地址是否可以保存 (转换包含中文无法完全转换) */
export function canSaveSupplierOrWarehouseAddress(data: any): API.Res<any> {
    return towerAftersaleRequest.post('/addresses/canSaveSupplierOrWarehouseAddress', { data })
}

/** 保存基础退货地址 (转换包含中文无法完全转换) */
export function saveBaseAddress(data: any): API.Res<boolean> {
    return towerAftersaleRequest.post('/addresses/saveBaseAddress', { data })
}

/** 保存基础退货地址 (转换包含中文无法完全转换) */
export function updateBaseAddress(data: any): API.Res<boolean> {
    return towerAftersaleRequest.post('/addresses/updateBaseAddress', { data })
}

/**
 * queryOptions
 */
export function queryOptionsUsingGET(params: QueryOptionsUsingGetParams): API.Res<MyChannelSimpleResult[]> {
    return drpRequest.get('/myChannel/queryOptions', { params })
}

/**
 * 查询策略关联分销商信息
 */
export function drpNamesUsingGET(params: DrpNamesUsingGetParams): API.Res<CoIdNameResult[]> {
    return towerAftersaleRequest.get('/automation/drpNames', { params })
}

/**
 * 有效退款给分销商自动化策略列表（最大11条）
 */
export function getValidRefundToDistributorRuleListUsingGET(
    params: GetValidRefundToDistributorRuleListUsingGetParams
): API.Res<AfterSaleAutoRuleCollectSimpleVO[]> {
    return towerAftersaleRequest.get('/automation/getValidRefundToDistributorRuleList', { params })
}
/**
 * 根据运单号查询售后单数量
 */
export function countAfterSaleOrdersByTrackingNumberUsingPOST(
    data: string[]
): API.Res<LogisticsAfterSaleStatResultVo[]> {
    return towerAftersaleRequest.post('/afterSales/statistics/countSelfAfterSaleOrdersByTrackingNumber', { data })
}
/**
 * 根据运单号查询售后单数量(分销商)
 */
export function countDisAfterSaleOrdersByTrackingNumberUsingPOST(
    data: string[]
): API.Res<LogisticsAfterSaleStatResultVo[]> {
    return towerAftersaleRequest.post('/afterSales/statistics/countDistributorAfterSaleOrdersByTrackingNumber', {
        data
    })
}

/**
 * 查询自动退款给分销商其它策略是否选中分销商
 */
export function getRefundToDistributorOtherRuleUsingPOST(
    data: GetRefundToDistributorOtherRuleParam
): API.Res<GetRefundToDistributorOtherRuleVO> {
    return towerAftersaleRequest.post('/automation/getRefundToDistributorOtherRulePickDrp', { data })
}

/**
 * 查询新增自动退款给分销商是否可全选分销商
 */
export function getRefundToDistributorCanAllDrpUsingGET(
    params: GetRefundToDistributorCanAllDrpUsingGetParams
): API.Res<boolean> {
    return towerAftersaleRequest.get('/automation/getRefundToDistributorCanAllDrp', { params })
}

/**
 * 基础地址关联店铺查询
 */
export function baseAddressShopUsingGET(params: BaseAddressShopUsingGetParams): API.Res<BaseAddressShopVO[]> {
    return towerAftersaleRequest.get('/addresses/baseAddressShop', { params })
}

/**
 * queryAsAutoRefundIntervalDay
 */
export function queryAsAutoRefundIntervalDayUsingPOST(data: CurrentUser): API.Res<number> {
    return towerRequest.post('/config/afterSale/autoRefund/config', { data })
}

/**
 * 基础地址关联店铺校验
 */
export function baseAddressShopCheckUsingGET(params: BaseAddressShopCheckUsingGetParams): API.Res<boolean> {
    return towerAftersaleRequest.get('/addresses/baseAddressShopCheck', { params })
}

/**
 * 自动提交供应商昨天数据统计 (转换包含中文无法完全转换)
 */
export function countAutoSubmitFailuresYesterdayUsingPOST(): API.Res<any> {
    return towerAftersaleRequest.post('/afterSales/statistics/countAutoSubmitFailuresYesterday')
}

/**
 * 待提交供应商数据统计 (转换包含中文无法完全转换)
 */
export function countPendingSupplierSubmissionsUsingPOST(data: any): API.Res<CountPendingSupplierSubmissionsVO> {
    return towerAftersaleRequest.post('/afterSales/pendingSubmissionToSupplier', { data })
}

/**
 * 查询目标省市
 */
export function queryTargetProvinceAndCityUsingGET(
    params: QueryTargetProvinceAndCityUsingGetParams
): API.Res<TargetProvinceAndCityVo> {
    return towerAftersaleRequest.get('/address/rule/queryTargetProvinceAndCity', { params })
}

/** 售后单据action统计 */
export function disAfterSaleStatisticsAction(
    params: DisAfterSaleStatisticsActionUsingGetParams
): API.Res<ErpAfterSaleCountVO[]> {
    return companyRequest.get('/afterSale/statistics/disAfterSaleStatisticsAction', { params })
}

/**
 * 获取店铺代发商品数量
 */
export function getShopDropShippingProductCountUsingPOST(
    data: GetShopDropShippingProductCountParam
): API.Res<ShopDropShippingProductCountVo[]> {
    return towerAftersaleRequest.post('/addresses/getShopDropShippingProductCount', { data })
}

/**
 * 获取店铺代发商品
 */
export function getShopDropShippingProductUsingPOST(
    data: GetShopDropShippingProductUsingGetParams
): API.Res<ShopDropShippingProductVo> {
    return towerAftersaleRequest.post('/addresses/getShopDropShippingProducts', { data })
}

/**
 * 一键生成代发商品的多地址退货策略
 */
export function generateMultiReturnPoliciesForDropShippingUsingPOST(
    data: string[]
): API.Res<GenerateMultiReturnPoliciesForDropShippingVo> {
    return towerAftersaleRequest.post('/addresses/generateMultiReturnPoliciesForDropShipping', { data })
}

/**
 * 获取多层供应商地址
 */
export function queryLevelSupplierReturnAddressUsingPOST(data: string[]): API.Res<LevelSupplierReturnAddressVo[]> {
    return towerAftersaleRequest.post('/addresses/queryLevelSupplierReturnAddress', { data })
}

/**
 * 查询售后问题登记配置V2
 */
export function getAfterSaleIssueRegistrationV2UsingGET(): API.Res<AfterSaleIssueTreeNodeVo[]> {
    return companyRequest.get('/afterSale/configs/getAfterSaleIssueRegistrationV2')
}

/**
 * 查询售后问题登记配置V1
 */
export function getAfterSaleIssueRegistrationV1UsingGET(): API.Res<string[]> {
    return companyRequest.get('/afterSale/configs/getAfterSaleIssueRegistrationV1')
}

/**
 * 保存售后问题登记V1
 */
export function saveAfterSaleIssueRegistrationV1UsingPOST(
    data: AfterSaleIssueTreeNodeVo[]
): API.Res<AfterSaleIssueTreeNodeVo[]> {
    return companyRequest.post('/afterSale/configs/saveAfterSaleIssueRegistrationV1', { data })
}
/**
 * 保存售后问题登记
 */
export function saveAfterSaleIssueRegistrationUsingPOST(
    data: AfterSaleIssueTreeNodeVo[]
): API.Res<AfterSaleIssueTreeNodeVo[]> {
    return companyRequest.post('/afterSale/configs/saveAfterSaleIssueRegistration', { data })
}

/**
 * 急速退款前置校验
 */
export function preVerifySpeedRefundEligibilityUsingPOST(data: integer[]): API.Res<PreVerifySpeedRefundEligibilityVo> {
    return towerAftersaleRequest.post('/afterSales/preVerifySpeedRefundEligibility', { data })
}

/**
 * 街道匹配 (转换包含中文无法完全转换)
 */
export function townMatchUsingPOST(data: any): API.Res<any> {
    return towerAftersaleRequest.post('/platform/address/townMatch', { data })
}

/**
 * 获取城镇列表 (转换包含中文无法完全转换)
 */
export function queryTownListUsingPOST(data: any): API.Res<any[]> {
    return towerAftersaleRequest.post('/platform/address/queryTownList', { data })
}

/**
 * 查询未使用的奇门仓列表 (转换包含中文无法完全转换)
 */
export function queryUnusedQiMenWarehouseListUsingGET(
    params: QueryUnusedQiMenWarehouseListUsingGetParams
): API.Res<any[]> {
    return towerAftersaleRequest.get('/automation/queryUnusedQiMenWarehouseList', { params })
}

/**
 * 查询同步上传退货地址策略记录列表
 */
export function queryReturnAddressSyncUploadRecordsUsingGET(params): API.Res<ReturnAddressSyncUploadRecordVo[]> {
    return towerAftersaleRequest.get('/addresses/queryReturnAddressSyncUploadRecords', { params })
}

/**
 * 查询同步上传退货地址策略记录详情列表
 */
export function queryReturnAddressSyncUploadRecordDetailsUsingGET(
    params: QueryReturnAddressSyncUploadRecordDetailsUsingGetParams
): API.Res<ReturnAddressSyncUploadRecordDetailVo[]> {
    return towerAftersaleRequest.get('/addresses/queryReturnAddressSyncUploadRecordDetails', { params })
}

/**
 * 根据记录ID查询有变更的供应商退货地址
 */
export function queryChangedSupplierReturnAddressByRecordIdUsingPost(
    data: QueryChangedSupplierReturnAddressByRecordIdUsingGetParams
): API.Res<ChangedSupplierReturnAddressVo[]> {
    return towerAftersaleRequest.post('/addresses/queryChangedSupplierReturnAddressByRecordId', { data })
}

/**
 * 查询同步上传退货地址策略记录商品详情列表
 */
export function queryReturnAddressSyncUploadRecordItemDetailsUsingGET(
    params: QueryReturnAddressSyncUploadRecordItemDetailsUsingGetParams
): API.Res<ReturnAddressSyncUploadRecordItemDetailVo[]> {
    return towerAftersaleRequest.get('/addresses/queryReturnAddressSyncUploadRecordItemDetails', { params })
}

/**
 * 查询同步上传退货地址策略记录
 */
export function queryReturnAddressSyncUploadRecordByIdUsingGET(
    params: QueryReturnAddressSyncUploadRecordByIdUsingGetParams
): API.Res<ReturnAddressSyncUploadRecordVo> {
    return towerAftersaleRequest.get('/addresses/queryReturnAddressSyncUploadRecordById', { params })
}

/**
 * 重新上传退货地址策略
 */
export function reloadReturnAddressStrategyUsingPOST(data: ReloadReturnAddressStrategyParam): API.Res<boolean> {
    return towerAftersaleRequest.post('/addresses/reloadReturnAddressStrategy', { data })
}

/**
 * 统计同步上传退货地址策略记录商品数量
 */
export function countUploadReturnAddressStrategyRecordProductCountUsingGet(
    params
): API.Res<CountUploadReturnAddressStrategyRecordItemCountVo> {
    return towerAftersaleRequest.get('/addresses/countUploadReturnAddressStrategyRecordProductCount', { params })
}
